// import "./article_newspage.css";

export const newsPage = (obj) => {
    return `
        <div class="row justify-content-md-center">
            <div class="col-md-10">
                <div class="article article__main">
                    <h1 class="article__header">${obj.title}</h1>
                    ${obj.parsedIntro.length > 2 ? `<div class="article__intro">${obj.parsedIntro}</div>` : ``}
                    <div class="col p-0">${obj.mainImage}</div>
                    <div class="article__content col-md-8 p-0">
                        ${obj.content}
                    </div>
                    <div class="article__content col-md-8 p-0 project__date__container">
                        <div class="">
                            <p>
                                ${obj.published != null ? `<span class="article__datetext article__datetext__date article__datetext__date-published"><span class="article__datetext__label">Publisert:</span> ${obj.published}</span><br/>`:``}
                                ${obj.modified != null ? `<span class="article__datetext article__datetext__date article__datetext__date-modified"><span class="article__datetext__label">Sist oppdatert:</span> ${obj.modified}</span>`:``}
                            </p>
                        </div>
                    </div>
                </div>
            </div>
            ${
                obj.hasRightColumn
                ? `<div class="col-sm-4 offset-sm-1">${obj.rightColumn}</div>`
                : ""
            }

        </div>
        
        `;
}